export const TIMEOUT = {
  SEARCH: 300,
  LOGOUT_ALERT: 5000,
};
